// extracted by mini-css-extract-plugin
module.exports = {"logo":"Brand_logo__aDSFw","burger":"Brand_burger__1tzKn","navbar":"Brand_navbar__359YV"};